import { getWindow } from '../../../utils/general';

export const ODTableHeaderData = (
  tableHeaderState: Array<{
    enabled: boolean;
  }>,
) => {
  return [
    {
      title: 'Date Created',
      style: { width: '125px', paddingLeft: '16px' },
      sort: false,
      showHeader: tableHeaderState?.[0]?.enabled,
    },
    {
      title: 'Order #',
      style: { width: '141px', paddingLeft: '16px' },
      sort: false,
      showHeader: tableHeaderState?.[1]?.enabled,
    },
    {
      title: 'Project',
      style: { width: '124px', padding: '0px 0 0px 16px' },
      sort: false,
      showHeader: tableHeaderState?.[2]?.enabled,
    },
    {
      title: 'PO/Job Name',
      style: { width: '124px', paddingLeft: '16px' },
      sort: false,
      showHeader: true,
    },
    {
      title: 'Status',
      style: { width: '110px', paddingLeft: '16px' },
      sort: false,
      showHeader: true,
    },
    {
      title: 'Exception',
      style: { width: '155px', paddingLeft: '16px' },
      sort: false,
      showHeader: tableHeaderState?.[5]?.enabled,
    },
    {
      title: 'Delivery Date',
      style: { width: '122px', textAlign: 'left', paddingLeft: '16px' },
      sort: false,
      showHeader: tableHeaderState?.[6]?.enabled,
    },
  ];
};

export const ODTableHeaderValues = () => {
  const tableHeaderValuesLocalStorage =
    getWindow()?.sessionStorage?.getItem('tableHeaders') ?? '';

  if (tableHeaderValuesLocalStorage !== '') {
    const tableHeaderValues = JSON?.parse(tableHeaderValuesLocalStorage);
    return tableHeaderValues;
  }

  return [
    {
      columnName: 'Date Created',
      enabled: true,
    },
    {
      columnName: 'Order #',
      enabled: true,
    },
    {
      columnName: 'Project',
      enabled: true,
    },
    {
      columnName: 'PO/Job Name',
      enabled: true,
    },
    {
      columnName: 'Status',
      enabled: true,
    },
    {
      columnName: 'Exception',
      enabled: true,
    },
    {
      columnName: 'Delivery Date',
      enabled: true,
    },
  ];
};
